import { useHistory } from 'react-router';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { appSelectors } from 'redux/ducks/app';
import { checkPathMatchV2 } from 'helpers/app.helper';
import { FeatureFlagNames, RoutePath } from 'constants/app.constant';
import { courseSelectors } from 'reports/cw/redux/ducks/courses';
import { hadSelectors } from 'reports/had/redux/ducks/had';
import { isFeatureEnabled } from 'services/feature-flag.service';
import { PerformancePath } from 'reports/cw/constants/cw.constant';
import { PS_PILL_TITLES } from 'reports/ps/constants';
import { SH_PATHS } from 'reports/sh/constants/sh.constant';
import { shSelectors } from 'reports/sh/redux/ducks/sh';
import { HAD_PATHS } from 'reports/had/constants/had.constant';
var useCentralizedLandingPageCardsHook = function () {
    var history = useHistory();
    var allSHCourses = useSelector(shSelectors.getCourses);
    var selectedCourse = useSelector(appSelectors.getSelectedCourse);
    var featureFlags = useSelector(appSelectors.getFeatureFlags);
    var isNclexReportingEnabled = useSelector(appSelectors.getIsNclexReportingEnabled);
    var isTSPLinkFeatureEnabled = isFeatureEnabled(featureFlags, FeatureFlagNames.TSP_GATEWAY_LINK_FEATURE_ENABLED, selectedCourse === null || selectedCourse === void 0 ? void 0 : selectedCourse.toString());
    var isShEnabled = useSelector(appSelectors.getIsShEnabled);
    var isCWBentoBoxLinkShow = useSelector(appSelectors.getIsCWBentoBoxLinkShow);
    var isProgramFetching = useSelector(hadSelectors.getIsProgramsFetching);
    var isCourseFetching = useSelector(courseSelectors.getIsCourseFetching);
    var isHADDisable = !isTSPLinkFeatureEnabled || !isNclexReportingEnabled;
    var onHADNavigation = useCallback(function () {
        var path = RoutePath.had;
        if (!isHADDisable) {
            history.push(path);
        }
    }, [isHADDisable, history]);
    var isCWDisable = !isTSPLinkFeatureEnabled || !isCWBentoBoxLinkShow;
    var onCWNavigation = useCallback(function () {
        if (!isCWDisable) {
            var path = PerformancePath.courseAggregate;
            history.push(path);
        }
    }, [isCWDisable, history]);
    var isPRDDisable = !isTSPLinkFeatureEnabled || !isShEnabled;
    var onPRDNavigation = useCallback(function () {
        if (!isPRDDisable) {
            var courseAggregate = SH_PATHS.courseAggregate, dashboard = SH_PATHS.dashboard;
            var path = (allSHCourses === null || allSHCourses === void 0 ? void 0 : allSHCourses.length) > 1 ? courseAggregate : dashboard;
            history.push(path);
        }
    }, [allSHCourses === null || allSHCourses === void 0 ? void 0 : allSHCourses.length, history, isPRDDisable]);
    var reportConfigs = useMemo(function () { return [
        {
            title: 'HESI Readiness for NCLEX Dashboard',
            description: 'Gain insights into student preparedness for the NCLEX exam, focusing on critical readiness indicators.',
            color: 'blue',
            icon: 'Statistics',
            iconColor: 'u-els-color-secondary',
            text: PS_PILL_TITLES.HESI,
            onNavigation: onHADNavigation,
            disabled: isHADDisable,
            loading: isProgramFetching,
            isSelected: checkPathMatchV2(Object.values(HAD_PATHS))
        },
        {
            title: 'Sherpath Performance & Grades Dashboard',
            description: 'Gain insights into student engagement and the mastery of foundational skills throughout the course.',
            color: 'green',
            icon: 'Neuroimagery',
            text: PS_PILL_TITLES.SHERPATH,
            onNavigation: onCWNavigation,
            disabled: isCWDisable,
            loading: isCourseFetching,
            isSelected: checkPathMatchV2(Object.values(PerformancePath).flatMap(function (value) { return (typeof value === 'string' ? value : Object.values(value)); }))
        },
        {
            title: 'Practice Readiness Dashboard',
            description: 'Gain insights into student development of clinical judgment skills in Shadow Health, preparing them for hands-on clinical experience.',
            color: 'orange',
            icon: 'Stethoscope',
            text: PS_PILL_TITLES.SHADOW_HEALTH,
            onNavigation: onPRDNavigation,
            disabled: isPRDDisable,
            loading: false,
            pillClassName: 'c-centralized-landing-page__content__pill-prd',
            isSelected: checkPathMatchV2(Object.values(SH_PATHS))
        }
    ]; }, [isCWDisable, isCourseFetching, isHADDisable, isPRDDisable, isProgramFetching, onCWNavigation, onHADNavigation, onPRDNavigation]);
    return { reportConfigs: reportConfigs };
};
export default useCentralizedLandingPageCardsHook;
